import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

enum ButtonStyle {
  Default = 'default',
  Secondary = 'secondary',
  Basic = 'basic'
}

@Component({
  selector: 'pcs-button-wrapper',
  templateUrl: './button-wrapper.component.html',
  styleUrls: ['./button-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonWrapperComponent {

  @Input() infoText;
  @Input() buttonStyle = ButtonStyle.Default;

  @HostBinding('class.button-wrapper-default')
  private get isDefault() {
    return this.buttonStyle === ButtonStyle.Default;
  }

  @HostBinding('class.button-wrapper-secondary')
  private get isSecondary() {
    return this.buttonStyle === ButtonStyle.Secondary;
  }

  @HostBinding('class.button-wrapper-basic')
  private get isBasic() {
    return this.buttonStyle === ButtonStyle.Basic;
  }
}
